__turbopack_context__.v({
  "container": "GeneralEventPanelInfo-module-scss-module__7hBZ8a__container",
  "content": "GeneralEventPanelInfo-module-scss-module__7hBZ8a__content",
  "ctaButtonWrapper": "GeneralEventPanelInfo-module-scss-module__7hBZ8a__ctaButtonWrapper",
  "date": "GeneralEventPanelInfo-module-scss-module__7hBZ8a__date",
  "label": "GeneralEventPanelInfo-module-scss-module__7hBZ8a__label",
});
